module.exports = __webpack_public_path__ + "img/project-progress.b6751e78.svg";